<template>
  <v-tooltip v-if="chip" bottom>
    <template v-slot:activator="{ on, attrs }">
      <v-avatar
        v-bind="{ ...attrs, ...$attrs }"
        v-on="on"
        :color="chip.color"
        :style="avatarStyle"
        size="16"
        class="event-signal-avatar">
        <v-icon v-if="false" small :color="chip.textColor">{{ chip.icon }}</v-icon>
      </v-avatar>
    </template>
    <span>{{ chipHint }}</span>
  </v-tooltip>
</template>

<script>
import { EVENT_SIGNAL_STATUS, getEventSignalChipData } from './eventSignal'

export default {
  name: 'EventSignalChip',
  inheritAttrs: false,
  props: {
    status: {
      type: String,
      default: EVENT_SIGNAL_STATUS.IDLE,
    },
  },
  computed: {
    chip() {
      return getEventSignalChipData(this.status)
    },
    chipHint() {
      if (!this.chip) {
        return ''
      }

      if (this.chip.labelKey) {
        return this.$t(this.chip.labelKey)
      }

      return this.chip.label || ''
    },
    avatarStyle() {
      const mode = this.$vuetify.theme.dark ? 'dark' : 'light'
      const currentTheme = this.$vuetify.theme.themes?.[mode] || {}
      const surfaceColor = currentTheme.background || (this.$vuetify.theme.dark ? '#1E1E1E' : '#FFFFFF')

      return {
        boxShadow: `0 0 0 2px ${surfaceColor}`,
      }
    },
  },
}
</script>

<style scoped>
.event-signal-avatar {
  cursor: pointer;
}
</style>
